import * as CONSTANTS from "../utils/constants/constants";
import axios from "./axiosInstance";
import {
    ReceivingFacility,
    ValidatedAddress,
} from "../interfaces/ReceivingFacility";

const BASE_URL = () => CONSTANTS.HOST + "api/v1/receiving-facilities/";

const authHeaders = (access_token: string) => ({
    headers: { authorization: "Bearer " + access_token },
});

class ReceivingFacilityService {
    // routing: also say whether each facility is on the routing map (slower; the list page's Routable column)
    static listUrl(routing = false) {
        return BASE_URL() + (routing ? "?routing=1" : "");
    }

    static create(data: ReceivingFacility, access_token: string) {
        return axios
            .post(BASE_URL(), data, authHeaders(access_token))
            .then((response: any) => response.data as ReceivingFacility)
            .catch((err: any) => Promise.reject(err.response || err));
    }

    static update(id: string, data: ReceivingFacility, access_token: string) {
        return axios
            .patch(`${BASE_URL()}${id}/`, data, authHeaders(access_token))
            .then((response: any) => response.data as ReceivingFacility)
            .catch((err: any) => Promise.reject(err.response || err));
    }

    static remove(id: string, access_token: string) {
        return axios
            .delete(`${BASE_URL()}${id}/`, authHeaders(access_token))
            .catch((err: any) => Promise.reject(err.response || err));
    }

    static validateAddress(address: string, access_token: string) {
        return axios
            .post(
                `${BASE_URL()}address-validation/`,
                { address },
                authHeaders(access_token)
            )
            .then((response: any) => response.data as ValidatedAddress)
            .catch((err: any) => Promise.reject(err.response || err));
    }
}

export default ReceivingFacilityService;
